<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'ProductRecipe_Title' | translateWF: 'Product Recipes' }}</h1>
        @if (canEdit()) {
          <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="goToDetails()" />
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'ProductRecipe_Title' | translateWF: 'Product Recipes'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="listRecipes()" selectionMode="single" (onSort)="onSort($event)" [lazy]="true">
            <ng-template pTemplate="header">
              <tr class="primary__header">
                <th pSortableColumn="Number">
                  {{ 'ProductRecipe_Number' | translateWF: 'Number' }}
                  <p-sortIcon field="Number" />
                </th>
                <th pSortableColumn="Name">
                  {{ 'ProductRecipe_Name' | translateWF: 'Name' }}
                  <p-sortIcon field="Name" />
                </th>
                <th pSortableColumn="OutputItemCode">
                  {{ 'ProductRecipe_OutputItemCode' | translateWF: 'Item Master Code' }}
                  <p-sortIcon field="OutputItemCode" />
                </th>
                <th>
                  {{ 'ProductRecipe_Status' | translateWF: 'Status' }}
                </th>
                <th pSortableColumn="BaseQuantity">
                  {{ 'ProductRecipe_BaseQuantity' | translateWF: 'Base Qty' }}
                  <p-sortIcon field="BaseQuantity" />
                </th>
                <th>
                  {{ 'ProductRecipe_UOM' | translateWF: 'UOM' }}
                </th>
                <th pSortableColumn="CreatedDate">
                  {{ 'Common_Created' | translateWF: 'Created' }}
                  <p-sortIcon field="CreatedDate" />
                </th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let recipe = getRowData(rowData);
              <tr (click)="goToDetails(recipe.id)">
                <td class="truncate">
                  <a>{{ recipe.number }}</a>
                </td>
                <td class="truncate">
                  {{ recipe.name }}
                </td>
                <td class="truncate">
                  {{ recipe.outputItemCode }}
                </td>
                <td class="truncate">
                  {{ statuses()[recipe.status] | pascalToNormalCase }}
                </td>
                <td>
                  {{ recipe.baseQuantity }}
                </td>
                <td class="truncate">
                  {{ uoms()[recipe.outputUOM] || recipe.outputUOM }}
                </td>
                <td class="truncate">
                  {{ recipe.createdDate | date: 'dd/MM/yyyy' }}
                </td>
                <td class="!text-end">
                  <p-button icon="pi pi-trash" variant="outlined" [disabled]="!canDelete(recipe)" (click)="deletePopup($event, recipe)" />
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8">
                  {{ 'ProductRecipe_Not_Found' | translateWF: 'No product recipes found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 25, 50]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
  <p-confirmdialog key="deleteProductRecipe" />
</main>
